import * as yup from 'yup';
import Concrete5 from 'assets/svg/wh_icon_Concrete-5.svg';
import Drupal from 'assets/svg/wh_icon_drupal.svg';
import Joomla from 'assets/svg/wh_icon_joomla.svg';
import Magento from 'assets/svg/wh_icon_magento.svg';
import WP from 'assets/svg/wh_icon_wp.svg';

export const whStep1Data = [
  {
    id: 'register_a_new_domain',
    value: 'register_a_new_domain',
  },
  {
    id: 'transfer_an_existing_domain',
    value: 'transfer_an_existing_domain',
  },
  {
    id: 'no_need_for_a_domain',
    value: 'no_need_for_a_domain',
  },
];

export const initialValueOfTransferDomain = {
  transfer_domain: '',
};

export const validationSchemaOfTransferDomain = yup.object({
  transfer_domain: yup
    .string()
    .required('wh/create.step1_string3')
    .max(64, 'wh/create.step1_string8')
    .matches(/^(?!-)(?!.*-$)[A-Za-z0-9-]{1,63}(\.[A-Za-z]{2,})+$/, 'wh/create.step1_string9'),
});

export const initialValue = {
  new_domain: '',
};

export const validationSchema = yup.object({
  new_domain: yup
    .string()
    .required('wh/create.step1_string3')
    .max(64, 'wh/create.step1_string8')
    .matches(/^(?!-)(?!.*-$)[A-Za-z0-9-]{1,63}(\.[A-Za-z]{2,})+$/, 'wh/create.step1_string9'),
});

export const getAppImage = (name) => {
  switch (name) {
    case 'concretecms':
      return Concrete5;
    case 'drupal':
      return Drupal;
    case 'joomla':
      return Joomla;
    case 'magento':
      return Magento;
    case 'wp':
      return WP;
    default:
      return '';
  }
};

export const sizesData = [
  {
    heading: 'wh/create.step2_string4',
    description: [
      { text: `wh/create.step2_string5` },
      { text: `wh/create.step2_string6` },
      { text: `wh/create.step2_string9` },
      { text: `wh/create.step2_string10` },
    ],
  },
  {
    heading: 'wh/create.step2_string11',
    description: [
      { text: `wh/create.step2_string12` },
      { text: `wh/create.step2_string13` },
      { text: `wh/create.step2_string14` },
    ],
  },
  {
    heading: 'wh/create.step2_string15',
    description: [
      { text: `wh/create.step2_string16` },
      { text: `wh/create.step2_string17` },
      { text: `wh/create.step2_string18` },
      { text: `wh/create.step2_string19` },
      { text: `wh/create.step2_string20` },
      { text: `wh/create.step2_string21` },
    ],
  },
];
export const domainTabs = {
  register_a_new_domain: 'register_a_new_domain',
  transfer_an_existing_domain: 'transfer_an_existing_domain',
  no_need_for_a_domain: 'no_need_for_a_domain',
};
export const whCreateInitialValue = {
  result: {},
  domain: '',
  size: '',
  region: '',
  app: '',
  options_prepaid: 12,
  domain_checked: domainTabs.register_a_new_domain,
  prices: {
    domain: 0,
    size: 0,
    yearly: {
      size: 0,
      domain: 0,
    },
  },
};

export const whCreateValidationSchema = (validations = {}) =>
  yup.object({
    size: yup
      .object({
        id: yup.string().required('Something wrong with the data'),
      })
      .required('wh/create.step1_string14'),
    region: yup.string().required('wh/create.step1_string15'),
    app: yup.string().required('wh/create.step1_string16'),
    options_prepaid: yup.string().required('wh/create.step1_string17'),
    ...validations,
  });
